'use client';

import { VideoDisplay } from '@/shared';
import ImgClient from '@/components/private/image-client';
import { useNavigation } from '@/app/navigation-context';

export function VideoElement({ video, sizes, }: { video: VideoDisplay, sizes?: string }) {
  const href = video?.slug ? `/video/${video.slug}` : ``;
  const { loadingHref, navigate, } = useNavigation();
  const isLoading = loadingHref === href;

  if (!video?.slug) {
    console.log(`Missing video slug`);
    return <></>;
  }

  if (!video?.poster) {
    console.log(`Missing video poster`);
    return <></>;
  }

  return (
    <a href={href} onClick={(e) => { e.preventDefault(); navigate(href); }} style={{ position: `relative`, }}>
      {isLoading && (
        <div className="nav-loading-overlay">
          <div className="animate-spin h-8 w-8 border-4 border-white border-t-transparent rounded-full" />
        </div>
      )}
      <ImgClient
        image={video.poster}
        signedUrls={video.poster.signedUrls}
        placeholder={video.poster.placeholder ?? ``}
        sizes={sizes} />
      <p>{video.title}</p>
    </a>
  );
}
